<template>
  <div>
    <Loading v-if="loading" />
    <!-- Ticket Search -->
    <div>
      <!-- Form -->
      <div>
        <FormulateForm @submit="searchTickets">
          <FormulateInput
            type="text"
            v-model="ticketSearchQuery"
            label="Search by ticket name or ID"
            placeholder="e.g. 1234567"
            error-behavior="submit"
          />
          <FormulateInput
            v-for="field in apidata.system.booking_fields"
            :key="field.hubspot_property_id"
            :type="field.type"
            :options="
              field.fetchOptions
                ? apidata.metadata.options[field.hubspot_property_id].options
                : field.options
            "
            v-model="filters[field.hubspot_property_id]"
            :label="field.label"
            error-behavior="submit"
          />
          <div style="font-size:12px;margin-bottom:5px;">Note: you may only filter by 3 fields at once due to a HubSpot limitation.</div>
          <FormulateInput type="submit" name="Search" />
        </FormulateForm>
      </div>
      <!-- Results -->
      <div class="cards" style="margin-top: 30px; max-width: 600px">
        <div
          v-for="ticket in searchResults"
          :key="ticket.id"
          class="card"
          @click="selectTicket(ticket.id)"
        >
          {{ ticket.properties.subject }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
export default {
  data: function() {
    return {
      loading: null,
      ticketSearchQuery: null,
      searchResults: null,
      filters: {},
    };
  },

  methods: {
    searchTickets: async function() {
      try {
        this.loading = true;

        if (this.ticketSearchQuery && this.ticketSearchQuery.length < 3)
          throw new Error("Query has to be more than 2 characters");
        const response = await this.$axios({
          method: "post",
          url: "https://enuf79mumn6lhhr.m.pipedream.net",
          params: {
            query: this.ticketSearchQuery,
            pipeline_id: this.apidata.system.ticket_pipeline_id,
          },
          data: {
            filters: this.filters,
          },
        });

        this.searchResults = response.data.tickets;
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    selectTicket: async function(ticket_id) {
      const routeData = this.$router.resolve(`/tickets/${ticket_id}`);
      window.open(routeData.href, "_blank");
    },
  },

  created: async function() {},
};
</script>

<style scoped>
.statuses {
  display: flex;
}

.status {
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid lightgrey;
  padding: 10px;
  overflow: auto;
  text-align: center;
}

.status h4 {
  font-size: 12.5px;
}

.status:first-child {
  border-left: 1px solid lightgrey;
}

.tickets {
  height: 600px;
  margin-top: 20px;
  width: 100%;
}

.contact {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  margin-bottom: 25px;
  border-bottom: 1px solid rgb(201, 201, 201);
  align-items: center;
  margin-right: 20px;
}

.contact h4 {
  color: var(--primary-color);
}

.contact div {
  margin-bottom: 5px;
}

.contact .left {
  margin-right: 10px;
}

.contacts {
  max-height: 400px;
  overflow: auto;
}

.ticket-info:not(:first-child) {
  border-left: 4px solid var(--primary-color);
  padding-left: 5px;
  margin-top: 5px;
}

.mini-label {
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 12px;
  color: grey;
}

.mini-label:not(:first-child) {
  margin-top: 20px;
}

input[type="checkbox"] {
  transform: scale(1.5);
}
</style>
